<template>
    <h3>Please wait....Checking your profile</h3>
</template>
<script>
    //import axios from 'axios'
    import instance from "../helper/http";
    import { store } from '../store/store'
    import router from '../router'
    import { authHeader, AuthURL } from "../helper";
    
    export default {
        
        created() {
            this.checkProfile()
        },
        methods: {
            checkProfile() {
                
                instance.get(AuthURL + "profile", {
                    headers: authHeader(),
                    })
                        .then((response) => {
                           
                            store.commit("cradLog", response.data.isCrad);
                            store.commit("viewerLog", response.data.isViewer);
                            //if (response.data.changepassword) {
                            //    store.dispatch("logout");
                            //    window.location.href = '/static/changepass.html';
                            //}
                            //if (response.data.disabled) {
                            //    store.dispatch("logout");
                            //    window.location.href = '/static/disabled.html';
                            //}
                            if (!response.data.tfa) {
                                store.dispatch("logout");
                                window.location.href = '/static/twofactor.html';
                            }
                            store.commit("login", true);
                            store.commit("profile", true);
                           
                            //localStorage.setItem("token", token)
                            router.replace({ name: "Dash" });

                        })
                
                
                
            },
            //Login() {
            //    this.$store.commit("login", true);
            //}
        }
    }
</script>